import { useEffect, useState } from "react";
import api, { inr, fmtDate } from "@/lib/api";
import { TableToolbar, matches, exportRows, Empty } from "./shared";
import { ReferralBonuses } from "./ReferralBonuses";

const COLUMNS = [
  { label: "Joined", value: (u) => fmtDate(u.created_at) },
  { label: "Name", value: "name" },
  { label: "Email", value: "email" },
  { label: "Phone", value: "phone" },
  { label: "Investments", value: "count" },
  { label: "Total Committed (₹)", value: "committed" },
  { label: "Referral Code", value: "referral_code" },
  { label: "Referred By", value: "referred_by_name" },
  { label: "Referrals", value: "referrals" },
];

export const InvestorsTab = () => {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    Promise.all([api.get("/admin/users"), api.get("/admin/investments")])
      .then(([u, inv]) => {
        const byUser = {};
        inv.data.forEach((i) => {
          byUser[i.user_id] ??= { count: 0, committed: 0 };
          byUser[i.user_id].count += 1;
          if (i.status === "active" || i.status === "completed") byUser[i.user_id].committed += i.amount;
        });
        setItems(u.data.filter((x) => x.role !== "admin").map((x) => ({ ...x, ...(byUser[x.id] || { count: 0, committed: 0 }) })));
      })
      .catch(() => {});
  }, []);
  const rows = items.filter((i) => matches(i, q));
  return (
    <div data-testid="admin-investors-tab">
      <ReferralBonuses />
      <TableToolbar title="Investors" count={rows.length} query={q} onQuery={setQ} placeholder="Search name, email, phone…" testId="investors" onExport={() => exportRows("investors", COLUMNS, rows)} />
      <div className="border border-white/10">
        <div className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-white/10 font-accent text-[10px] tracking-[0.2em] uppercase text-white/35">
          <span className="col-span-3">Investor</span>
          <span className="col-span-3">Contact</span>
          <span className="col-span-2">Referral</span>
          <span className="col-span-1">Invest.</span>
          <span className="col-span-3">Committed</span>
        </div>
        {rows.map((u) => (
          <div key={u.id} className="grid grid-cols-12 gap-4 px-6 py-5 border-b border-white/10 last:border-0 items-center" data-testid={`investor-row-${u.id}`}>
            <div className="col-span-3">
              <p className="text-sm text-white">{u.name}</p>
              <p className="text-xs text-white/35 mt-1">Joined {fmtDate(u.created_at)}</p>
              {u.referred_by_name && <p className="text-xs text-[#D4AF37]/80 mt-1" data-testid={`investor-referred-by-${u.id}`}>Referred by {u.referred_by_name}</p>}
            </div>
            <div className="col-span-3 text-xs text-white/60">
              <p>{u.email}</p>
              <p className="mt-1">{u.phone || "—"}</p>
            </div>
            <div className="col-span-2 text-xs">
              <p className="font-mono text-white/70 tracking-widest" data-testid={`investor-code-${u.id}`}>{u.referral_code || "—"}</p>
              <p className="text-white/35 mt-1" data-testid={`investor-referrals-${u.id}`}>{u.referrals || 0} sign-up{u.referrals === 1 ? "" : "s"}</p>
            </div>
            <span className="col-span-1 text-sm text-white">{u.count}</span>
            <span className="col-span-3 text-sm text-[#D4AF37]">{inr(u.committed)}</span>
          </div>
        ))}
        {rows.length === 0 && <Empty testId="investors-empty" text={q ? "No investors match your search." : "No investors registered yet."} />}
      </div>
    </div>
  );
};
